import { Injectable, signal } from '@angular/core';

export enum ToastType {
  Danger = 'danger',
  Success = 'success',
  Warning = 'warning',
  Info = 'info',
}

export interface Toast {
  type: ToastType;
  title: string;
  message: string;
  delay?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts = signal<Toast[]>([]);
  readonly toasts = this._toasts.asReadonly();

  public danger(message: string, title?: string, delay?: number) {
    this._toasts.update((toasts) => [
      ...toasts,
      { title, message, delay, type: ToastType.Danger },
    ]);
  }

  public success(message: string, title?: string, delay?: number) {
    this._toasts.update((toasts) => [
      ...toasts,
      { title, message, delay, type: ToastType.Success },
    ]);
  }

  public warning(message: string, title?: string, delay?: number) {
    this._toasts.update((toasts) => [
      ...toasts,
      { title, message, delay, type: ToastType.Warning },
    ]);
  }

  public info(message: string, title?: string, delay?: number) {
    this._toasts.update((toasts) => [
      ...toasts,
      { title, message, delay, type: ToastType.Info },
    ]);
  }

  public remove(toast: Toast) {
    this._toasts.update((toasts) => toasts.filter((t) => t !== toast));
  }

  public clear() {
    this._toasts.set([]);
  }
}
